import { apiDate } from '@/platform/lib/utils';
import { Button, Form, FormGroup, Input, Select } from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import SidePanel from './SidePanel';

const LkvEntitlementPanel = ({ entitlement, onClose }) => {
    const { employee, categories, states } = usePage().props;

    const { data, setData, patch, processing, errors } = useForm({
        category: entitlement.category ?? '',
        state: entitlement.state ?? '',
        start_date: apiDate(entitlement.start_date) ?? '',
        end_date: apiDate(entitlement.end_date) ?? '',
    });

    const handleSubmit = event => {
        event.preventDefault();

        patch(
            `/customers/${employee.customer_id}/employees/${employee.id}/lkv/${entitlement.id}`,
            {
                reset: ['employee', 'navigation'],
                preserveScroll: true,
                onSuccess: onClose,
            }
        );
    };

    return (
        <SidePanel
            title='LKV-recht wijzigen'
            subtitle='Velden met * zijn verplicht.'
            onClose={onClose}
            footer={
                <div className='flex justify-end gap-2'>
                    <Button type='button' onClick={onClose}>
                        Annuleren
                    </Button>
                    <Button
                        type='submit'
                        form='lkv-entitlement'
                        variant='primary'
                        loading={processing}
                    >
                        Wijzigingen opslaan
                    </Button>
                </div>
            }
        >
            <Form id='lkv-entitlement' onSubmit={handleSubmit}>
                <FormGroup>
                    <Select
                        label='Categorie'
                        description='Bepaalt het uurbedrag en het maximum per jaar.'
                        required
                        value={data.category}
                        onChange={event =>
                            setData('category', event.target.value)
                        }
                        options={categories}
                        error={errors.category}
                    />
                    <Select
                        label='Status'
                        description='Alleen rechten met de status Voltooid tellen mee in de berekening.'
                        required
                        value={data.state}
                        onChange={event => setData('state', event.target.value)}
                        options={states}
                        error={errors.state}
                    />
                    <Input
                        type='date'
                        label='Startdatum'
                        required
                        value={data.start_date}
                        onChange={event =>
                            setData('start_date', event.target.value)
                        }
                        error={errors.start_date}
                    />
                    <Input
                        type='date'
                        label='Einddatum'
                        description='Laat leeg als het recht structureel is.'
                        value={data.end_date}
                        onChange={event =>
                            setData('end_date', event.target.value)
                        }
                        error={errors.end_date}
                    />
                </FormGroup>
            </Form>
        </SidePanel>
    );
};

export default LkvEntitlementPanel;
